import * as React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

function MarketLinkIcon(props: React.ComponentProps<typeof SvgIcon>) {
  return (
    <SvgIcon {...props} viewBox="0 0 11 14">
      <g fill="#000" fillRule="evenodd">
        <path d="M0 4h10.667L5.333 0zM0 12.667h10.667V14H0zM.667 5.333H2v6H.667zM4.667 5.333H6v6H4.667zM8.667 5.333H10v6H8.667z" />
      </g>
    </SvgIcon>
  );
}

export { MarketLinkIcon };
